import React, {FC} from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';

import * as AppRoutes from '../../appRoutes';
import {useUser} from '../../hooks/useUser';
import {getLog} from '../../log';
import ErrorBoundary from '../ErrorBoundary';
import Page from '../common/Page';
import PageTitle from '../common/PageTitle';
import {SubmenuFc, SubmenuItemFc} from '../common/Submenu';
import {RerouterFc} from '../management/Rerouter';
import {Changelogs} from './Changelogs';
import {DocumentsCommercial} from './DocumentsCommercial';
import {DocumentsTechnical} from './DocumentsTechnical';

const log = getLog('DocumentsMain');

export const Documents: FC = (props) => {
  const {loadingUser, isTelia} = useUser();
  log.debug('render', props);

  const subPath = AppRoutes.useSubPath(AppRoutes.DOCUMENTATION);

  const {formatWithBrand} = AppRoutes.useBrandFormat();
  return (
    <Page>
      <PageTitle title="Documents" />
      <SubmenuFc ariaLabel={'Management submenu'}>
        <SubmenuItemFc link={formatWithBrand(AppRoutes.DOCUMENTATION_TECHNICAL)} text="Technical" />
        <SubmenuItemFc link={formatWithBrand(AppRoutes.DOCUMENTATION_COMMERCIAL)} text="Commercial" />
        {isTelia() && (
          <SubmenuItemFc link={formatWithBrand(AppRoutes.DOCUMENTATION_PRODUCT_CHANGES)} text="Product Changes" />
        )}
      </SubmenuFc>

      <ErrorBoundary key={location.pathname}>
        <Routes>
          <Route
            path={subPath(AppRoutes.DOCUMENTATION)}
            element={<Navigate replace to={formatWithBrand(AppRoutes.DOCUMENTATION_TECHNICAL)} />}
          />
          <Route path={subPath(AppRoutes.DOCUMENTATION_TECHNICAL)} element={<DocumentsTechnical />} />
          <Route path={subPath(AppRoutes.DOCUMENTATION_COMMERCIAL)} element={<DocumentsCommercial />} />
          <Route
            path={subPath(AppRoutes.DOCUMENTATION_PRODUCT_CHANGES)}
            element={
              <RerouterFc
                isDisplayed={loadingUser || !!isTelia()}
                navigateTo={formatWithBrand(AppRoutes.DOCUMENTATION)}
              >
                <Changelogs />
              </RerouterFc>
            }
          />
        </Routes>
      </ErrorBoundary>
    </Page>
  );
};
